export const links = {
  instagram: "https://www.instagram.com/rebouncesurat/",
  facebook: "https://www.facebook.com/rebouncesurat",
  google: "https://www.google.com/search?q=rebounce%20surat",
};
